// app/frontend/pages/Onboarding/steps/StepComplete.tsx
import { Stack, Box } from "@mantine/core";
import { IconCheck, IconRocket } from "@tabler/icons-react";
import { StepShell } from "../../../components/ui/Stepper";
import { L2KText } from "../../../components/ui/Typography";
import type { StepComponentProps } from "../../../components/ui/Stepper";
import type { OnboardingFormValues } from "../types";

interface StepCompleteProps extends StepComponentProps<OnboardingFormValues> {
  isSubmitted?: boolean;
}

export function StepComplete({ isSubmitted = false }: StepCompleteProps) {
  if (!isSubmitted) {
    return (
      <StepShell
        title="You're all set!"
        subtitle="Click complete to start your journey"
      >
        <Stack gap="lg" align="center" py="md">
          <Box
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 87, 34, 0.2))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid rgba(255, 152, 0, 0.3)",
            }}
          >
            <IconRocket size={40} color="#FF9800" />
          </Box>

          <L2KText ta="center">
            We've got everything we need. Ready to dive in?
          </L2KText>
        </Stack>
      </StepShell>
    );
  }

  return (
    <StepShell title="Welcome aboard!" subtitle="Your profile is complete">
      <Stack gap="lg" align="center" py="md">
        <Box
          style={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #22C55E, #16A34A)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 20px rgba(34, 197, 94, 0.4)",
            animation: "pulse 2s ease-in-out infinite",
          }}
        >
          <IconCheck size={40} color="#fff" stroke={3} />
        </Box>

        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                box-shadow: 0 0 20px rgba(34, 197, 94, 0.4);
              }
              50% {
                box-shadow: 0 0 30px rgba(34, 197, 94, 0.6);
              }
            }
          `}
        </style>

        <Stack gap="xs" align="center">
          <L2KText ta="center">
            Your personalized learning experience is ready.
          </L2KText>
          <L2KText variant="secondary" ta="center" size="sm">
            Redirecting you to the dashboard...
          </L2KText>
        </Stack>
      </Stack>
    </StepShell>
  );
}

export default StepComplete;
